/**
 * useRequirePermission — STORY-008-006 (admin shell, Task 4).
 *
 * Imperative per-slug permission check for admin page components (button-level
 * gating, e.g. hide a bulk-import action a viewer-only admin can't perform).
 * Reads the SAME shared `/me` query as RequireAdminAuth / RequirePermissionRoute
 * (`useMe`, cached under ["me"]) — no divergent refetch. Server RBAC is the real
 * enforcement; this only drives UX affordances.
 */
import { useMe } from "@/features/settings/api";

export function useRequirePermission(slug: string): boolean {
  const { data: profile } = useMe();
  return (profile?.permissions ?? []).includes(slug);
}
